import styled from 'styled-components';

const Arrow = styled.span `
  position: absolute;
  padding-left: 4px;

  /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
  color: hsl(0, 0%, 0%, 0.25);

  ::after {
    content: ' →';
  }
`;

export { Arrow as default };
